import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ImageComponent } from '@pedix-workspace/angular-ui-image';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import {
  IconAlertComponent,
  IconClockComponent,
  IconTrashCanComponent,
} from '@pedix-workspace/angular-ui-icons';

@Component({
  selector: 'pxw-cart-product-header',
  templateUrl: './cart-product-header.component.html',
  styleUrls: ['./cart-product-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImageComponent,
    TagComponent,
    IconAlertComponent,
    IconClockComponent,
    IconTrashCanComponent,
  ],
  host: {
    '[class.product-header--editable]': '!readOnly() && isCategoryAvailable()',
    '[class.product-header--readonly]': 'readOnly()',
  },
})
export class CartProductHeaderComponent {
  readonly productName = input.required<string>();
  readonly productImage = input<string | undefined>(undefined);
  readonly displayImage = input(true);
  readonly productSku = input<string | undefined>(undefined);
  readonly displaySku = input.required<boolean>();
  readonly readOnly = input(false);
  readonly isCategoryAvailable = input.required<boolean>();
  readonly isProductUnavailable = input(false);
  readonly withoutImageLabel = input.required<string>();
  readonly notAvailableLabel = input.required<string>();
  readonly productNotAvailableLabel = input.required<string>();
  readonly warningNote = input<string | undefined>(undefined);

  readonly edit = output<void>();
  readonly removeAll = output<void>();
  readonly openAvailability = output<void>();

  onEdit() {
    if (this.readOnly() || !this.isCategoryAvailable()) {
      return;
    }
    this.edit.emit();
  }
}
